/** Extract YouTube video ID from ID string or common URL formats. */
export function extractYoutubeId(value) {
  if (!value || typeof value !== "string") return "";

  const trimmed = value.trim();
  if (!trimmed) return "";

  if (/^[\w-]{11}$/.test(trimmed)) {
    return trimmed;
  }

  try {
    const url = trimmed.startsWith("http")
      ? new URL(trimmed)
      : new URL(`https://${trimmed}`);

    if (url.hostname.includes("youtu.be")) {
      return url.pathname.replace("/", "").split("/")[0] || "";
    }

    if (url.searchParams.get("v")) {
      return url.searchParams.get("v");
    }

    const embedMatch = url.pathname.match(/\/embed\/([\w-]{11})/);
    if (embedMatch) {
      return embedMatch[1];
    }
  } catch {
    /* not a URL */
  }

  const idPart = trimmed.split(/[?&#/]/)[0];
  return /^[\w-]{11}$/.test(idPart) ? idPart : trimmed.split("?")[0];
}

export function buildYoutubeEmbedUrl(videoId) {
  const params = new URLSearchParams({
    origin: window.location.origin,
    iv_load_policy: "3",
    modestbranding: "1",
    playsinline: "1",
    rel: "0",
    enablejsapi: "1",
  });

  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
}
